module.exports = __webpack_public_path__ + "static/premium-web@2x-c6b28dd07e33886aee5563c06e22022e.png";